import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
export var Select = forwardRef(function (_a, ref) {
    var options = _a.options, className = _a.className, selectProps = __rest(_a, ["options", "className"]);
    return (React.createElement("select", __assign({ ref: ref }, selectProps, { className: "w-full border-gray-300 border rounded p-1 text-xl " + className }), options.map(function (opt) { return (React.createElement("option", { key: opt.label + "" + opt.value, value: opt.value }, opt.label)); })));
});
//# sourceMappingURL=Select.js.map